import React, { useState, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import '../../components/styles/CardGenerator.css';
import '../../components/styles/InstructionOne.css';
import cardLogo from '../../img/vipe-card-logo.png';
import redCardLogo from '../../img/vipe-red-card-logo.png';
import wordingLogo from '../../img/wording-card-logo.png';
import titleLogo from '../../img/big-vipe-logo.png';
import vineta from '../../img/list-item.png';
import hands from '../../img/hands.png';
import phone from '../../img/phone-icon.png';
import ReactToPrint from "react-to-print";
// import { ENDPOINT_TOKEN } from '../../components/OnlineForm/helpers/HandleFieldChange.jsx';

const CardGeneration = ({language, formData, onClose, onNextPage}) => {
  const { t } = useTranslation();
  const marginLeft = language === 'en' ? '223px' : '215px';
  const [logos, setLogos] = useState([]);
  const cardGeneratorRef = useRef();

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  }, []);

  useEffect(() => {
    const fetchLogos = async () => {
      try {
        const response = await fetch(`https://vipe.uy/services/get_sponsors.php`);
        const data = await response.json();
        setLogos(data.logos);
      } catch (error) {
      }
    };

    fetchLogos();
  }, []);

  function getCurrentDate() {
    const currentDate = new Date();
    return `${currentDate.getDate()}/${currentDate.getMonth() + 1}/${currentDate.getFullYear()}`;
  }

  formData.date = getCurrentDate();

  function insertLineBreaks(text) {
    const regex = new RegExp(`.{1,${40}}`, 'g');
    const lines = text.match(regex);

    if (lines) {
      return lines.join('<br>');
    } else {
      return text;
    }
  }

  const handleAfterPrint = () => {
    onNextPage();
  }

  return (
  <>
  <div className='main'>
    <div className='btn-finish-card'>
      <div className='row-one'>
        <button className='square-button-back-card' onClick={onClose}>
          <span className="button-text">{t('form.previous')}</span>
        </button>
        <ReactToPrint
          trigger={() => 
            <button className='square-button-next-card'>
              <span className="button-text">{t('card.download')}</span>
            </button>
            }
          content={() => cardGeneratorRef.current}
          documentTitle={t('card.fileName')}
          // onAfterPrint={handleAfterPrint}
        />
        <button className='square-button-next-card' onClick={handleAfterPrint}>
          <span className="button-text">{t('form.next')}</span>
        </button>
      </div>
    </div>
    <div id="cardGenerator" className="cardGenerator" ref={cardGeneratorRef}>
        
        <div className='firstPage'>

            <div>
              <img src={titleLogo} className='print-logo' alt={'print-logo'} />
              <div className='print-title-wording'>
                <p className='vipePNormal'>{t('wordings.thanks')}&nbsp;</p>
                <p className='vipePStrong'>{t('wordings.vipe')}</p>
                <p className='vipePNormal'>&nbsp;{t('wordings.emergencyCard')}</p>
              </div>
              <div className='originalForPrint'>{t('wordings.originalForPrint')}</div>
            </div>
            <div className='list-div'>
              <div className='listItem'>
                <img src={vineta} alt='vineta' className='vineta'/>
                <p>{t('wordings.p1')}</p>
              </div>
              <div className='listItem'>
                <img src={vineta} alt='vineta' className='vineta'/>
                <p>{t('wordings.p2')}</p>
              </div>
              <div className='listItem'>
                <img src={vineta} alt='vineta' className='vineta'/>
                <p style={{marginBottom: '5px'}}>{t('wordings.p3')}</p>
              </div>
              <div className='listItem-li'>
                <p>{t('wordings.p3li1')}</p>
                <p>{t('wordings.p3li2')}</p>
                <p style={{marginBottom: '0px'}}>{t('wordings.p3li3')}</p>
              </div>
              <div className='listItem'>
                <img src={vineta} alt='vineta' className='vineta'/>
                <p>{t('wordings.p4')}</p>
              </div>
              <div className='listItem'>
                <img src={vineta} alt='vineta' className='vineta'/>
                <p>{t('wordings.p5')}</p>
              </div>
              <div className='listItem'>
                <img src={vineta} alt='vineta' className='vineta'/>
                <p>{t('wordings.p6')}</p>
              </div>
              <div className='listItem'>
                <img src={vineta} alt='vineta' className='vineta'/>
                <p>{t('wordings.p7')}</p>
              </div>
              <div className='listItem'>
                <img src={vineta} alt='vineta' className='vineta'/>
                <p><strong>{t('wordings.ready')}</strong>&nbsp;{t('wordings.p8')}</p>
              </div>
              <div className='listItem'>
                <img src={vineta} alt='vineta' className='vineta'/>
                <p className='p9'>{t('wordings.p9')}</p>
              </div>
              <div className='listItem'>
                <img src={vineta} alt='vineta' className='vineta'/>
                <p>{t('wordings.p10')}&nbsp;<a href={t('card.mainSiteUrl')} target='_blank' rel='noopener noreferrer' className='email'>{t('wordings.email')}</a></p>
              </div>
            </div>
            {/* <div className='foot' style={{marginTop: '18px'}}>
              <div className='centeredText'>Pag. 1</div>
              <div className='footImage'>
                <img src={footLogo} alt='foot-logo' className='footLogo'/>
              </div>
            </div> */}
        </div>

        <div className='secondPage'>
          <div className='second-page-header'>
            <img src={titleLogo} className='print-logo' alt={'print-logo'} />
            <p>{t('wordings.header')}</p>
          </div>
          <div className='cut-here-lines'>
            <div className='dotted-line'></div>
            <p>{t('wordings.cutdottedline')}</p>
            <div className='simple-line'></div>
            <p>{t('wordings.cutsimpleline')}</p>
          </div>
        {/* ================ WHITE CARDS START HERE ================*/}
          <div className='card-row'>

            <div className="card">
              <div className="front">
                <div className="card-title">
                  <img src={cardLogo} alt='logo-title' className='card-title-logo' />
                  <img src={wordingLogo} alt='wording-title' className='card-title-wording' />
                </div>
                <div className="name">
                  {formData.name.toUpperCase()} {formData.lastName.toUpperCase()}
                </div>
                <div className="country-identityDocument">
                  <div className="country">{formData.country}</div>
                  <div className="identityDocument">{formData.identityDocument}</div>
                </div>
                <div className='medical-emergency'>
                  <div className='health-service'>{formData.healthServiceProvider}</div>
                  <div className='emergency-service'>{formData.emergencyMedicalService}</div>
                </div>
                <div className="date-blood">
                  <div className="dateOfBirth">
                    <div className="pBirth">{t('card.birth')}</div>
                    <div className="birthValue">{formData.dateOfBirth}</div>
                  </div>
                  <div className="bloodGroup">
                    <div className="pBloodGroup">{t('card.bloodGroup')}</div>
                    <div className="bloodGroupValue">{formData.bloodGroup}</div>
                  </div>
                  <div className="preferredHand">
                    {/* Mano izquierda */}
                    <label>
                      <input
                        className="check-hand"
                        type="checkbox"
                        name="hand"
                        value="left"
                        checked={formData.preferredHand === 'Izquierda' || formData.preferredHand === 'Left'}
                        readOnly
                      />
                    </label>
                      <img src={hands} alt="Both hands" className="hand-image"/>
                      {/* Mano derecha */}
                    <label>
                      <input
                        className="check-hand"
                        type="checkbox"
                        name="hand"
                        value="right"
                        checked={formData.preferredHand === 'Derecha' || formData.preferredHand === 'Right'}
                        readOnly
                      />
                    </label>
                  </div>
                </div>
                <div className='phone-promo'>
                <div className="phone-div">
                  <div className='phone-image'><img src={phone} alt='phoneImage' className='phone-image' /></div>
                  <div className='phoneValues'>
                  {formData.phones.map((phoneNumber, index) => (
                    <div key={index}>{phoneNumber}</div>
                  ))}
                  </div>
                </div>
                  <div className='promoCode-div'>
                  <div className='wording-promoCode'>{formData.promotionalCode ? t('card.courtesy') : null}</div>
                      <div className='promoCodeValue'>
                        {logos.map((logo, index) => {
                          if (formData.promotionalCode === logo.empresaMostrar) {
                            return (
                              <div key={index} className='promoCodeValue'>
                                <img src={`data:image/png;base64,${logo.rutaImagen}`} alt={logo.empresaMostrar} className='promoCodeValue'/>
                              </div>
                            );
                          } else {
                            return null;
                          }
                        })}
                      </div>
                  </div>
                </div>
              </div>
            </div>
            
            <div className="card">
              <div className="back">
                <div className="card-title">
                  <img src={cardLogo} alt='logo-title' className='card-title-logo' />
                  <img src={wordingLogo} alt='wording-title' className='card-title-wording' />
                </div>
                <div className='back-form-data'>
                  <div className='conditions-commentary'>
                    <div className='conditions'>
                      {formData.conditions.map((condition, index) => (
                        <div key={index} className="disease">
                          <div className="diseaseName">{condition.diseaseName.toUpperCase()}</div>
                          {condition.medication && (
                            <div className="medication">
                              <div className='medicationName'>{condition.diseaseName ? condition.medication.medicationName : null}</div>

                              <div className='separator-div'>{condition.diseaseName && condition.medication.medicationName ? '/' : null}</div>

                              <div className='dosage'>{condition.diseaseName ?  condition.medication.dosage : null}</div>

                              <div className='separator-div'>{condition.diseaseName && condition.medication.dosage ? '/' : null}</div>

                              <div className='frequency'>
                                {condition.diseaseName && condition.medication.frequency ? `${condition.medication.frequency} / ${t('card.day')}` : ''}
                              </div>
                            </div>
                          )}
                        </div>
                      ))}
                    </div>
                    <div className='commentary-div'>
                      <div className='wording-commentary'>{t('card.commentaryDot')}</div>
                      <div className='commentaryValue' dangerouslySetInnerHTML={{ __html: insertLineBreaks(formData.commentary) }} />
                    </div>
                  </div>
                  <div className='card-footer' style={{marginLeft}}>{t('card.emision')} {formData.date}</div>
                </div>
              </div>
            </div>

          </div>

          <div className='card-row'>

            <div className="card">
              <div className="front">
                <div className="card-title">
                  <img src={cardLogo} alt='logo-title' className='card-title-logo' />
                  <img src={wordingLogo} alt='wording-title' className='card-title-wording' />
                </div>
                <div className="name">
                  {formData.name.toUpperCase()} {formData.lastName.toUpperCase()}
                </div>
                <div className="country-identityDocument">
                  <div className="country">{formData.country}</div>
                  <div className="identityDocument">{formData.identityDocument}</div>
                </div>
                <div className='medical-emergency'>
                  <div className='health-service'>{formData.healthServiceProvider}</div>
                  <div className='emergency-service'>{formData.emergencyMedicalService}</div>
                </div>
                <div className="date-blood">
                  <div className="dateOfBirth">
                    <div className="pBirth">{t('card.birth')}</div>
                    <div className="birthValue">{formData.dateOfBirth}</div>
                  </div>
                  <div className="bloodGroup">
                    <div className="pBloodGroup">{t('card.bloodGroup')}</div>
                    <div className="bloodGroupValue">{formData.bloodGroup}</div>
                  </div>
                  <div className="preferredHand">
                    {/* Mano izquierda */}
                    <label>
                      <input
                        className="check-hand"
                        type="checkbox"
                        name="hand"
                        value="left"
                        checked={formData.preferredHand === 'Izquierda' || formData.preferredHand === 'Left'}
                        readOnly
                      />
                    </label>
                      <img src={hands} alt="Both hands" className="hand-image"/>
                      {/* Mano derecha */}
                    <label>
                      <input
                        className="check-hand"
                        type="checkbox"
                        name="hand"
                        value="right"
                        checked={formData.preferredHand === 'Derecha' || formData.preferredHand === 'Right'}
                        readOnly
                      />
                    </label>
                  </div>
                </div>
                <div className='phone-promo'>
                <div className="phone-div">
                  <div className='phone-image'><img src={phone} alt='phoneImage' className='phone-image' /></div>
                  <div className='phoneValues'>
                  {formData.phones.map((phoneNumber, index) => (
                    <div key={index}>{phoneNumber}</div>
                  ))}
                  </div>
                </div>
                  <div className='promoCode-div'>
                  <div className='wording-promoCode'>{formData.promotionalCode ? t('card.courtesy') : null}</div>
                      <div className='promoCodeValue'>
                        {logos.map((logo, index) => {
                          if (formData.promotionalCode === logo.empresaMostrar) {
                            return (
                              <div key={index} className='promoCodeValue'>
                                <img src={`data:image/png;base64,${logo.rutaImagen}`} alt={logo.empresaMostrar} className='promoCodeValue'/>
                              </div>
                            );
                          } else {
                            return null;
                          }
                        })}
                      </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="card">
              <div className="back">
                <div className="card-title">
                  <img src={cardLogo} alt='logo-title' className='card-title-logo' />
                  <img src={wordingLogo} alt='wording-title' className='card-title-wording' />
                </div>
                <div className='back-form-data'>
                  <div className='conditions-commentary'>
                    <div className='conditions'>
                      {formData.conditions.map((condition, index) => (
                        <div key={index} className="disease">
                        <div className="diseaseName">{condition.diseaseName.toUpperCase()}</div>
                        {condition.medication && (
                          <div className="medication">
                            <div className='medicationName'>{condition.diseaseName ? condition.medication.medicationName : null}</div>

                            <div className='separator-div'>{condition.diseaseName && condition.medication.medicationName ? '/' : null}</div>

                            <div className='dosage'>{condition.diseaseName ?  condition.medication.dosage : null}</div>

                            <div className='separator-div'>{condition.diseaseName && condition.medication.dosage ? '/' : null}</div>

                            <div className='frequency'>
                              {condition.diseaseName && condition.medication.frequency ? `${condition.medication.frequency} / ${t('card.day')}` : ''}
                            </div>
                          </div>
                        )}
                      </div>
                      ))}
                    </div>
                    <div className='commentary-div'>
                      <div className='wording-commentary'>{t('card.commentaryDot')}</div>
                      <div className='commentaryValue' dangerouslySetInnerHTML={{ __html: insertLineBreaks(formData.commentary) }} />
                    </div>
                  </div>
                  <div className='card-footer' style={{marginLeft}}>{t('card.emision')} {formData.date}</div>
                </div>
              </div>
            </div>

          </div>

          <div className='card-row'>

            <div className="card">
              <div className="front">
                <div className="card-title">
                  <img src={cardLogo} alt='logo-title' className='card-title-logo' />
                  <img src={wordingLogo} alt='wording-title' className='card-title-wording' />
                </div>
                <div className="name">
                  {formData.name.toUpperCase()} {formData.lastName.toUpperCase()}
                </div>
                <div className="country-identityDocument">
                  <div className="country">{formData.country}</div>
                  <div className="identityDocument">{formData.identityDocument}</div>
                </div>
                <div className='medical-emergency'>
                  <div className='health-service'>{formData.healthServiceProvider}</div>
                  <div className='emergency-service'>{formData.emergencyMedicalService}</div>
                </div>
                <div className="date-blood">
                  <div className="dateOfBirth">
                    <div className="pBirth">{t('card.birth')}</div>
                    <div className="birthValue">{formData.dateOfBirth}</div>
                  </div>
                  <div className="bloodGroup">
                    <div className="pBloodGroup">{t('card.bloodGroup')}</div>
                    <div className="bloodGroupValue">{formData.bloodGroup}</div>
                  </div>
                  <div className="preferredHand">
                    {/* Mano izquierda */}
                    <label>
                      <input
                        className="check-hand"
                        type="checkbox"
                        name="hand"
                        value="left"
                        checked={formData.preferredHand === 'Izquierda' || formData.preferredHand === 'Left'}
                        readOnly
                      />
                    </label>
                      <img src={hands} alt="Both hands" className="hand-image"/>
                      {/* Mano derecha */}
                    <label>
                      <input
                        className="check-hand"
                        type="checkbox"
                        name="hand"
                        value="right"
                        checked={formData.preferredHand === 'Derecha' || formData.preferredHand === 'Right'}
                        readOnly
                      />
                    </label>
                  </div>
                </div>
                <div className='phone-promo'>
                <div className="phone-div">
                  <div className='phone-image'><img src={phone} alt='phoneImage' className='phone-image' /></div>
                  <div className='phoneValues'>
                  {formData.phones.map((phoneNumber, index) => (
                    <div key={index}>{phoneNumber}</div>
                  ))}
                  </div>
                </div>
                  <div className='promoCode-div'>
                  <div className='wording-promoCode'>{formData.promotionalCode ? t('card.courtesy') : null}</div>
                      <div className='promoCodeValue'>
                        {logos.map((logo, index) => {
                          if (formData.promotionalCode === logo.empresaMostrar) {
                            return (
                              <div key={index} className='promoCodeValue'>
                                <img src={`data:image/png;base64,${logo.rutaImagen}`} alt={logo.empresaMostrar} className='promoCodeValue'/>
                              </div>
                            );
                          } else {
                            return null;
                          }
                        })}
                      </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="card">
              <div className="back">
                <div className="card-title">
                  <img src={cardLogo} alt='logo-title' className='card-title-logo' />
                  <img src={wordingLogo} alt='wording-title' className='card-title-wording' />
                </div>
                <div className='back-form-data'>
                  <div className='conditions-commentary'>
                    <div className='conditions'>
                      {formData.conditions.map((condition, index) => (
                        <div key={index} className="disease">
                        <div className="diseaseName">{condition.diseaseName.toUpperCase()}</div>
                        {condition.medication && (
                          <div className="medication">
                            <div className='medicationName'>{condition.diseaseName ? condition.medication.medicationName : null}</div>

                            <div className='separator-div'>{condition.diseaseName && condition.medication.medicationName ? '/' : null}</div>

                            <div className='dosage'>{condition.diseaseName ?  condition.medication.dosage : null}</div>

                            <div className='separator-div'>{condition.diseaseName && condition.medication.dosage ? '/' : null}</div>

                            <div className='frequency'>
                              {condition.diseaseName && condition.medication.frequency ? `${condition.medication.frequency} / ${t('card.day')}` : ''}
                            </div>
                          </div>
                        )}
                      </div>
                      ))}
                    </div>
                    <div className='commentary-div'>
                      <div className='wording-commentary'>{t('card.commentaryDot')}</div>
                      <div className='commentaryValue' dangerouslySetInnerHTML={{ __html: insertLineBreaks(formData.commentary) }} />
                    </div>
                  </div>
                  <div className='card-footer' style={{marginLeft}}>{t('card.emision')} {formData.date}</div>
                </div>
              </div>
            </div>

          </div>

          <div className='card-row'>

          <div className="card">
            <div className="front">
              <div className="card-title">
                <img src={cardLogo} alt='logo-title' className='card-title-logo' />
                <img src={wordingLogo} alt='wording-title' className='card-title-wording' />
              </div>
              <div className="name">
                {formData.name.toUpperCase()} {formData.lastName.toUpperCase()}
              </div>
              <div className="country-identityDocument">
                <div className="country">{formData.country}</div>
                <div className="identityDocument">{formData.identityDocument}</div>
              </div>
              <div className='medical-emergency'>
                <div className='health-service'>{formData.healthServiceProvider}</div>
                <div className='emergency-service'>{formData.emergencyMedicalService}</div>
              </div>
              <div className="date-blood">
                <div className="dateOfBirth">
                  <div className="pBirth">{t('card.birth')}</div>
                  <div className="birthValue">{formData.dateOfBirth}</div>
                </div>
                <div className="bloodGroup">
                  <div className="pBloodGroup">{t('card.bloodGroup')}</div>
                  <div className="bloodGroupValue">{formData.bloodGroup}</div>
                </div>
                <div className="preferredHand">
                  {/* Mano izquierda */}
                  <label>
                    <input
                      className="check-hand"
                      type="checkbox"
                      name="hand"
                      value="left"
                      checked={formData.preferredHand === 'Izquierda' || formData.preferredHand === 'Left'}
                      readOnly
                    />
                  </label>
                    <img src={hands} alt="Both hands" className="hand-image"/>
                    {/* Mano derecha */}
                  <label>
                    <input
                      className="check-hand"
                      type="checkbox"
                      name="hand"
                      value="right"
                      checked={formData.preferredHand === 'Derecha' || formData.preferredHand === 'Right'}
                      readOnly
                    />
                  </label>
                </div>
              </div>
              <div className='phone-promo'>
              <div className="phone-div">
                <div className='phone-image'><img src={phone} alt='phoneImage' className='phone-image' /></div>
                <div className='phoneValues'>
                {formData.phones.map((phoneNumber, index) => (
                  <div key={index}>{phoneNumber}</div>
                ))}
                </div>
              </div>
                <div className='promoCode-div'>
                <div className='wording-promoCode'>{formData.promotionalCode ? t('card.courtesy') : null}</div>
                    <div className='promoCodeValue'>
                      {logos.map((logo, index) => {
                        if (formData.promotionalCode === logo.empresaMostrar) {
                          return (
                            <div key={index} className='promoCodeValue'>
                              <img src={`data:image/png;base64,${logo.rutaImagen}`} alt={logo.empresaMostrar} className='promoCodeValue'/>
                            </div>
                          );
                        } else {
                          return null;
                        }
                      })}
                    </div>
                </div>
              </div>
            </div>
          </div>

          <div className="card">
            <div className="back">
              <div className="card-title">
                <img src={cardLogo} alt='logo-title' className='card-title-logo' />
                <img src={wordingLogo} alt='wording-title' className='card-title-wording' />
              </div>
              <div className='back-form-data'>
                <div className='conditions-commentary'>
                  <div className='conditions'>
                      {formData.conditions.map((condition, index) => (
                        <div key={index} className="disease">
                        <div className="diseaseName">{condition.diseaseName.toUpperCase()}</div>
                        {condition.medication && (
                          <div className="medication">
                            <div className='medicationName'>{condition.diseaseName ? condition.medication.medicationName : null}</div>

                            <div className='separator-div'>{condition.diseaseName && condition.medication.medicationName ? '/' : null}</div>

                            <div className='dosage'>{condition.diseaseName ?  condition.medication.dosage : null}</div>

                            <div className='separator-div'>{condition.diseaseName && condition.medication.dosage ? '/' : null}</div>

                            <div className='frequency'>
                              {condition.diseaseName && condition.medication.frequency ? `${condition.medication.frequency} / ${t('card.day')}` : ''}
                            </div>
                          </div>
                        )}
                      </div>
                      ))}
                    </div>
                  <div className='commentary-div'>
                    <div className='wording-commentary'>{t('card.commentaryDot')}</div>
                    <div className='commentaryValue' dangerouslySetInnerHTML={{ __html: insertLineBreaks(formData.commentary) }} />
                  </div>
                </div>
                <div className='card-footer' style={{marginLeft}}>{t('card.emision')} {formData.date}</div>
              </div>
            </div>
          </div>

          </div>
          {/* <div className='foot'>
            <div className='centeredText'>Pag. 2</div>
            <div className='footImage'>
              <img src={footLogo} alt='foot-logo' className='footLogo'/>
            </div>
          </div> */}
        </div>
        <div className='thirdPage'>
          <div className='second-page-header'>
            <img src={titleLogo} className='print-logo' alt={'print-logo'} />
            <p>{t('wordings.header')}</p>
          </div>
          <div className='cut-here-lines'>
            <div className='dotted-line'></div>
            <p>{t('wordings.cutdottedline')}</p>
            <div className='simple-line'></div>
            <p>{t('wordings.cutsimpleline')}</p>
          </div>
          {/* ================ RED CARDS START HERE ================*/}
          <div className='card-row'>

            <div className="card">
              <div className="front-red">
                <div className="card-title">
                  <img src={redCardLogo} alt='logo-title' className='card-title-logo' />
                  <img src={wordingLogo} alt='wording-title' className='card-title-wording' />
                </div>
                <div className="name">
                  {formData.name.toUpperCase()} {formData.lastName.toUpperCase()}
                </div>
                <div className="country-identityDocument">
                  <div className="country">{formData.country}</div>
                  <div className="identityDocument">{formData.identityDocument}</div>
                </div>
                <div className='medical-emergency'>
                  <div className='health-service'>{formData.healthServiceProvider}</div>
                  <div className='emergency-service'>{formData.emergencyMedicalService}</div>
                </div>
                <div className="date-blood">
                  <div className="dateOfBirth">
                    <div className="pBirth">{t('card.birth')}</div>
                    <div className="birthValue">{formData.dateOfBirth}</div>
                  </div>
                  <div className="bloodGroup">
                    <div className="pBloodGroup">{t('card.bloodGroup')}</div>
                    <div className="bloodGroupValue">{formData.bloodGroup}</div>
                  </div>
                  <div className="preferredHand">
                    {/* Mano izquierda */}
                    <label>
                      <input
                        className="check-hand-red"
                        type="checkbox"
                        name="hand"
                        value="left"
                        checked={formData.preferredHand === 'Izquierda' || formData.preferredHand === 'Left'}
                        readOnly
                      />
                    </label>
                      <img src={hands} alt="Both hands" className="hand-image"/>
                      {/* Mano derecha */}
                    <label>
                      <input
                        className="check-hand-red"
                        type="checkbox"
                        name="hand"
                        value="right"
                        checked={formData.preferredHand === 'Derecha' || formData.preferredHand === 'Right'}
                        readOnly
                      />
                    </label>
                  </div>
                </div>
                <div className='phone-promo'>
                <div className="phone-div">
                  <div className='phone-image'><img src={phone} alt='phoneImage' className='phone-image' /></div>
                  <div className='phoneValues'>
                  {formData.phones.map((phoneNumber, index) => (
                    <div key={index}>{phoneNumber}</div>
                  ))}
                  </div>
                </div>
                  <div className='promoCode-div'>
                  <div className='wording-promoCode'>{formData.promotionalCode ? t('card.courtesy') : null}</div>
                      <div className='promoCodeValue'>
                        {logos.map((logo, index) => {
                          if (formData.promotionalCode === logo.empresaMostrar) {
                            return (
                              <div key={index} className='promoCodeValue'>
                                <img src={`data:image/png;base64,${logo.rutaImagen}`} alt={logo.empresaMostrar} className='promoCodeValue'/>
                              </div>
                            );
                          } else {
                            return null;
                          }
                        })}
                      </div>
                  </div>
                </div>
              </div>
            </div>
            
            <div className="card">
              <div className="back-red">
                <div className="card-title">
                  <img src={redCardLogo} alt='logo-title' className='card-title-logo' />
                  <img src={wordingLogo} alt='wording-title' className='card-title-wording' />
                </div>
                <div className='back-form-data'>
                  <div className='conditions-commentary'>
                    <div className='conditions'>
                      {formData.conditions.map((condition, index) => (
                        <div key={index} className="disease">
                        <div className="diseaseName">{condition.diseaseName.toUpperCase()}</div>
                        {condition.medication && (
                          <div className="medication">
                            <div className='medicationName'>{condition.diseaseName ? condition.medication.medicationName : null}</div>

                            <div className='separator-div'>{condition.diseaseName && condition.medication.medicationName ? '/' : null}</div>

                            <div className='dosage'>{condition.diseaseName ?  condition.medication.dosage : null}</div>

                            <div className='separator-div'>{condition.diseaseName && condition.medication.dosage ? '/' : null}</div>

                            <div className='frequency'>
                              {condition.diseaseName && condition.medication.frequency ? `${condition.medication.frequency} / ${t('card.day')}` : ''}
                            </div>
                          </div>
                        )}
                      </div>
                      ))}
                    </div>
                    <div className='commentary-div'>
                      <div className='wording-commentary'>{t('card.commentaryDot')}</div>
                      <div className='commentaryValue' dangerouslySetInnerHTML={{ __html: insertLineBreaks(formData.commentary) }} />
                    </div>
                  </div>
                  <div className='card-footer' style={{marginLeft}}>{t('card.emision')} {formData.date}</div>
                </div>
              </div>
            </div>
          
          </div>

          <div className='card-row'>

            <div className="card">
              <div className="front-red">
                <div className="card-title">
                  <img src={redCardLogo} alt='logo-title' className='card-title-logo' />
                  <img src={wordingLogo} alt='wording-title' className='card-title-wording' />
                </div>
                <div className="name">
                  {formData.name.toUpperCase()} {formData.lastName.toUpperCase()}
                </div>
                <div className="country-identityDocument">
                  <div className="country">{formData.country}</div>
                  <div className="identityDocument">{formData.identityDocument}</div>
                </div>
                <div className='medical-emergency'>
                  <div className='health-service'>{formData.healthServiceProvider}</div>
                  <div className='emergency-service'>{formData.emergencyMedicalService}</div>
                </div>
                <div className="date-blood">
                  <div className="dateOfBirth">
                    <div className="pBirth">{t('card.birth')}</div>
                    <div className="birthValue">{formData.dateOfBirth}</div>
                  </div>
                  <div className="bloodGroup">
                    <div className="pBloodGroup">{t('card.bloodGroup')}</div>
                    <div className="bloodGroupValue">{formData.bloodGroup}</div>
                  </div>
                  <div className="preferredHand">
                    {/* Mano izquierda */}
                    <label>
                      <input
                        className="check-hand-red"
                        type="checkbox"
                        name="hand"
                        value="left"
                        checked={formData.preferredHand === 'Izquierda' || formData.preferredHand === 'Left'}
                        readOnly
                      />
                    </label>
                      <img src={hands} alt="Both hands" className="hand-image"/>
                      {/* Mano derecha */}
                    <label>
                      <input
                        className="check-hand-red"
                        type="checkbox"
                        name="hand"
                        value="right"
                        checked={formData.preferredHand === 'Derecha' || formData.preferredHand === 'Right'}
                        readOnly
                      />
                    </label>
                  </div>
                </div>
                <div className='phone-promo'>
                <div className="phone-div">
                  <div className='phone-image'><img src={phone} alt='phoneImage' className='phone-image' /></div>
                  <div className='phoneValues'>
                  {formData.phones.map((phoneNumber, index) => (
                    <div key={index}>{phoneNumber}</div>
                  ))}
                  </div>
                </div>
                  <div className='promoCode-div'>
                  <div className='wording-promoCode'>{formData.promotionalCode ? t('card.courtesy') : null}</div>
                      <div className='promoCodeValue'>
                        {logos.map((logo, index) => {
                          if (formData.promotionalCode === logo.empresaMostrar) {
                            return (
                              <div key={index} className='promoCodeValue'>
                                <img src={`data:image/png;base64,${logo.rutaImagen}`} alt={logo.empresaMostrar} className='promoCodeValue'/>
                              </div>
                            );
                          } else {
                            return null;
                          }
                        })}
                      </div>
                  </div>
                </div>
              </div>
            </div>
            
            <div className="card">
              <div className="back-red">
                <div className="card-title">
                  <img src={redCardLogo} alt='logo-title' className='card-title-logo' />
                  <img src={wordingLogo} alt='wording-title' className='card-title-wording' />
                </div>
                <div className='back-form-data'>
                  <div className='conditions-commentary'>
                    <div className='conditions'>
                      {formData.conditions.map((condition, index) => (
                        <div key={index} className="disease">
                        <div className="diseaseName">{condition.diseaseName.toUpperCase()}</div>
                        {condition.medication && (
                          <div className="medication">
                            <div className='medicationName'>{condition.diseaseName ? condition.medication.medicationName : null}</div>

                            <div className='separator-div'>{condition.diseaseName && condition.medication.medicationName ? '/' : null}</div>

                            <div className='dosage'>{condition.diseaseName ?  condition.medication.dosage : null}</div>

                            <div className='separator-div'>{condition.diseaseName && condition.medication.dosage ? '/' : null}</div>

                            <div className='frequency'>
                              {condition.diseaseName && condition.medication.frequency ? `${condition.medication.frequency} / ${t('card.day')}` : ''}
                            </div>
                          </div>
                        )}
                      </div>
                      ))}
                    </div>
                    <div className='commentary-div'>
                      <div className='wording-commentary'>{t('card.commentaryDot')}</div>
                      <div className='commentaryValue' dangerouslySetInnerHTML={{ __html: insertLineBreaks(formData.commentary) }} />
                    </div>
                  </div>
                  <div className='card-footer' style={{marginLeft}}>{t('card.emision')} {formData.date}</div>
                </div>
              </div>
            </div>
          
          </div>

          <div className='card-row'>

            <div className="card">
              <div className="front-red">
                <div className="card-title">
                  <img src={redCardLogo} alt='logo-title' className='card-title-logo' />
                  <img src={wordingLogo} alt='wording-title' className='card-title-wording' />
                </div>
                <div className="name">
                  {formData.name.toUpperCase()} {formData.lastName.toUpperCase()}
                </div>
                <div className="country-identityDocument">
                  <div className="country">{formData.country}</div>
                  <div className="identityDocument">{formData.identityDocument}</div>
                </div>
                <div className='medical-emergency'>
                  <div className='health-service'>{formData.healthServiceProvider}</div>
                  <div className='emergency-service'>{formData.emergencyMedicalService}</div>
                </div>
                <div className="date-blood">
                  <div className="dateOfBirth">
                    <div className="pBirth">{t('card.birth')}</div>
                    <div className="birthValue">{formData.dateOfBirth}</div>
                  </div>
                  <div className="bloodGroup">
                    <div className="pBloodGroup">{t('card.bloodGroup')}</div>
                    <div className="bloodGroupValue">{formData.bloodGroup}</div>
                  </div>
                  <div className="preferredHand">
                    {/* Mano izquierda */}
                    <label>
                      <input
                        className="check-hand-red"
                        type="checkbox"
                        name="hand"
                        value="left"
                        checked={formData.preferredHand === 'Izquierda' || formData.preferredHand === 'Left'}
                        readOnly
                      />
                    </label>
                      <img src={hands} alt="Both hands" className="hand-image"/>
                      {/* Mano derecha */}
                    <label>
                      <input
                        className="check-hand-red"
                        type="checkbox"
                        name="hand"
                        value="right"
                        checked={formData.preferredHand === 'Derecha' || formData.preferredHand === 'Right'}
                        readOnly
                      />
                    </label>
                  </div>
                </div>
                <div className='phone-promo'>
                <div className="phone-div">
                  <div className='phone-image'><img src={phone} alt='phoneImage' className='phone-image' /></div>
                  <div className='phoneValues'>
                  {formData.phones.map((phoneNumber, index) => (
                    <div key={index}>{phoneNumber}</div>
                  ))}
                  </div>
                </div>
                  <div className='promoCode-div'>
                  <div className='wording-promoCode'>{formData.promotionalCode ? t('card.courtesy') : null}</div>
                      <div className='promoCodeValue'>
                        {logos.map((logo, index) => {
                          if (formData.promotionalCode === logo.empresaMostrar) {
                            return (
                              <div key={index} className='promoCodeValue'>
                                <img src={`data:image/png;base64,${logo.rutaImagen}`} alt={logo.empresaMostrar} className='promoCodeValue'/>
                              </div>
                            );
                          } else {
                            return null;
                          }
                        })}
                      </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="card">
              <div className="back-red">
                <div className="card-title">
                  <img src={redCardLogo} alt='logo-title' className='card-title-logo' />
                  <img src={wordingLogo} alt='wording-title' className='card-title-wording' />
                </div>
                <div className='back-form-data'>
                  <div className='conditions-commentary'>
                    <div className='conditions'>
                      {formData.conditions.map((condition, index) => (
                        <div key={index} className="disease">
                        <div className="diseaseName">{condition.diseaseName.toUpperCase()}</div>
                        {condition.medication && (
                          <div className="medication">
                            <div className='medicationName'>{condition.diseaseName ? condition.medication.medicationName : null}</div>

                            <div className='separator-div'>{condition.diseaseName && condition.medication.medicationName ? '/' : null}</div>

                            <div className='dosage'>{condition.diseaseName ?  condition.medication.dosage : null}</div>

                            <div className='separator-div'>{condition.diseaseName && condition.medication.dosage ? '/' : null}</div>

                            <div className='frequency'>
                              {condition.diseaseName && condition.medication.frequency ? `${condition.medication.frequency} / ${t('card.day')}` : ''}
                            </div>
                          </div>
                        )}
                      </div>
                      ))}
                    </div>
                    <div className='commentary-div'>
                      <div className='wording-commentary'>{t('card.commentaryDot')}</div>
                      <div className='commentaryValue' dangerouslySetInnerHTML={{ __html: insertLineBreaks(formData.commentary) }} />
                    </div>
                  </div>
                  <div className='card-footer' style={{marginLeft}}>{t('card.emision')} {formData.date}</div>
                </div>
              </div>
            </div>

          </div>

          <div className='card-row'>

            <div className="card">
              <div className="front-red">
                <div className="card-title">
                  <img src={redCardLogo} alt='logo-title' className='card-title-logo' />
                  <img src={wordingLogo} alt='wording-title' className='card-title-wording' />
                </div>
                <div className="name">
                  {formData.name.toUpperCase()} {formData.lastName.toUpperCase()}
                </div>
                <div className="country-identityDocument">
                  <div className="country">{formData.country}</div>
                  <div className="identityDocument">{formData.identityDocument}</div>
                </div>
                <div className='medical-emergency'>
                  <div className='health-service'>{formData.healthServiceProvider}</div>
                  <div className='emergency-service'>{formData.emergencyMedicalService}</div>
                </div>
                <div className="date-blood">
                  <div className="dateOfBirth">
                    <div className="pBirth">{t('card.birth')}</div>
                    <div className="birthValue">{formData.dateOfBirth}</div>
                  </div>
                  <div className="bloodGroup">
                    <div className="pBloodGroup">{t('card.bloodGroup')}</div>
                    <div className="bloodGroupValue">{formData.bloodGroup}</div>
                  </div>
                  <div className="preferredHand">
                    {/* Mano izquierda */}
                    <label>
                      <input
                        className="check-hand-red"
                        type="checkbox"
                        name="hand"
                        value="left"
                        checked={formData.preferredHand === 'Izquierda' || formData.preferredHand === 'Left'}
                        readOnly
                      />
                    </label>
                      <img src={hands} alt="Both hands" className="hand-image"/>
                      {/* Mano derecha */}
                    <label>
                      <input
                        className="check-hand-red"
                        type="checkbox"
                        name="hand"
                        value="right"
                        checked={formData.preferredHand === 'Derecha' || formData.preferredHand === 'Right'}
                        readOnly
                      />
                    </label>
                  </div>
                </div>
                <div className='phone-promo'>
                <div className="phone-div">
                  <div className='phone-image'><img src={phone} alt='phoneImage' className='phone-image' /></div>
                  <div className='phoneValues'>
                  {formData.phones.map((phoneNumber, index) => (
                    <div key={index}>{phoneNumber}</div>
                  ))}
                  </div>
                </div>
                  <div className='promoCode-div'>
                  <div className='wording-promoCode'>{formData.promotionalCode ? t('card.courtesy') : null}</div>
                      <div className='promoCodeValue'>
                        {logos.map((logo, index) => {
                          if (formData.promotionalCode === logo.empresaMostrar) {
                            return (
                              <div key={index} className='promoCodeValue'>
                                <img src={`data:image/png;base64,${logo.rutaImagen}`} alt={logo.empresaMostrar} className='promoCodeValue'/>
                              </div>
                            );
                          } else {
                            return null;
                          }
                        })}
                      </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="card">
              <div className="back-red">
                <div className="card-title">
                  <img src={redCardLogo} alt='logo-title' className='card-title-logo' />
                  <img src={wordingLogo} alt='wording-title' className='card-title-wording' />
                </div>
                <div className='back-form-data'>
                  <div className='conditions-commentary'>
                  <div className='conditions'>
                    {formData.conditions.map((condition, index) => (
                        <div key={index} className="disease">
                        <div className="diseaseName">{condition.diseaseName.toUpperCase()}</div>
                        {condition.medication && (
                          <div className="medication">
                            <div className='medicationName'>{condition.diseaseName ? condition.medication.medicationName : null}</div>

                            <div className='separator-div'>{condition.diseaseName && condition.medication.medicationName ? '/' : null}</div>

                            <div className='dosage'>{condition.diseaseName ?  condition.medication.dosage : null}</div>

                            <div className='separator-div'>{condition.diseaseName && condition.medication.dosage ? '/' : null}</div>

                            <div className='frequency'>
                              {condition.diseaseName && condition.medication.frequency ? `${condition.medication.frequency} / ${t('card.day')}` : ''}
                            </div>
                          </div>
                        )}
                      </div>
                    ))}
                  </div>
                    <div className='commentary-div'>
                      <div className='wording-commentary'>{t('card.commentaryDot')}</div>
                      <div className='commentaryValue' dangerouslySetInnerHTML={{ __html: insertLineBreaks(formData.commentary) }} />
                    </div>
                  </div>
                  <div className='card-footer' style={{marginLeft}}>{t('card.emision')} {formData.date}</div>
                </div>
              </div>
            </div>

          </div>
          {/* <div className='foot' style={{marginTop: '25px'}}>
            <div className='centeredText'>Pag. 3</div>
            <div className='footImage'>
              <img src={footLogo} alt='foot-logo' className='footLogo'/>
            </div>
          </div> */}
        </div>

    </div>
    <div className='btn-finish-card'>
      <div className='row-one'>
        <button className='square-button-back' onClick={onClose}>
          <span className="button-text">{t('form.previous')}</span>
        </button>
        <ReactToPrint
          trigger={() => 
            <button className='square-button-next' style={{width: '200px'}}>
              <span className="button-text">{t('card.download')}</span>
            </button>
            }
          content={() => cardGeneratorRef.current}
          documentTitle='Vipe_card'
          // onAfterPrint={handleAfterPrint}
        />
        <button className='square-button-next' onClick={handleAfterPrint}>
          <span className="button-text">{t('form.next')}</span>
        </button>
      </div>
    </div>
  </div>
  </>
  );
};

export default CardGeneration;
